import type { SimpleDate } from '@ph-react-ui/core';
import { format } from 'date-fns';

export function mapSimpleDateToString(date: SimpleDate | null) {
  if (!date) {
    return null;
  }
  return format(new Date(date.year, date.month, date.date), 'yyyy-MM-dd');
}
